// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
    --white: #ffffff;
}

.collectionPage {
    border: 1px solid black;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    /* background-color: var(--white); */
    /* background: var(--white); */
    color: black;
}

.collectionPage-hidden {
    display: none;
}

.collectionPageItemsButton {
    border: 1px solid black;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    padding: 0.5rem;
    cursor: pointer;
    width: -webkit-fill-available;
    margin-bottom: 0;
}

.collectionPageInfo {
    padding: 0.5rem;
}

.collectionPageInfoTopDiv {
    display: flex; 
    justify-content: space-between;
    max-height: 2rem;
}

.collectionPageInfoIdLabel {
    align-self: center;
}

.collectionPageDescription {
    height: 5rem;
    overflow-y: scroll;
}

.collectionPageInfoBottomDiv {
    display: grid;
    grid-template-columns: 75% 5% 20%;
    height: 2rem;
}

.collectionPageInfoBottomKeywordsLabel {
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap-mode: nowrap;
}

.collectionPageInfoBottomLicenseLabel {
    text-overflow: ellipsis;
    text-wrap-mode: nowrap;
}

.collectionPageScroll {
    overflow-y: auto;
    max-height: 19rem;
    border: 1px solid black;
    margin: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/components/cesium/stac-browser/BrowseCollections.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,kCAAkC;IAClC,oCAAoC;IACpC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB","sourcesContent":["#root {\n    --white: #ffffff;\n}\n\n.collectionPage {\n    border: 1px solid black;\n    border-bottom-left-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n    /* background-color: var(--white); */\n    /* background: var(--white); */\n    color: black;\n}\n\n.collectionPage-hidden {\n    display: none;\n}\n\n.collectionPageItemsButton {\n    border: 1px solid black;\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n    padding: 0.5rem;\n    cursor: pointer;\n    width: -webkit-fill-available;\n    margin-bottom: 0;\n}\n\n.collectionPageInfo {\n    padding: 0.5rem;\n}\n\n.collectionPageInfoTopDiv {\n    display: flex; \n    justify-content: space-between;\n    max-height: 2rem;\n}\n\n.collectionPageInfoIdLabel {\n    align-self: center;\n}\n\n.collectionPageDescription {\n    height: 5rem;\n    overflow-y: scroll;\n}\n\n.collectionPageInfoBottomDiv {\n    display: grid;\n    grid-template-columns: 75% 5% 20%;\n    height: 2rem;\n}\n\n.collectionPageInfoBottomKeywordsLabel {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-wrap-mode: nowrap;\n}\n\n.collectionPageInfoBottomLicenseLabel {\n    text-overflow: ellipsis;\n    text-wrap-mode: nowrap;\n}\n\n.collectionPageScroll {\n    overflow-y: auto;\n    max-height: 19rem;\n    border: 1px solid black;\n    margin: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
